import React, {useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import TemplateProtokol from "../../components/templates/TemplateProtokol";
import FormProtokol from "./FormProtokol";
import {PrintAll} from "../../components/utils/PrintAll";
import {PrintElem} from "../../components/utils/PrintElem";
// import './docGen.css';

export default function GenProtokol({defaultData}) {
  // console.log('GenProtokol defaultData', defaultData)
  const [templateData, setTemplateData] = useState(
    defaultData?.length
      ? [...defaultData]
      : [
          {
            num1: "",
            num2: "",
            course: "Курс",
            date: "2021-11-11",
            namePredsedatel: "Имя 1",
            name_Chel_com: "Имя 2",
            nameSecretar: "Имя 3",
            // date: dateFormat(newData?.created_at ? newData?.created_at : new Date()),
            // namePredsedatel: findStaff(newData, 1),
            // name_Chel_com: findStaff(newData, 2),
            // nameSecretar: findStaff(newData, 3),
            // commissionStaff: newData?.staff ? [...newData?.staff] : [],
            users: [{name: "Имя 4", testPr: "", testBall: "", sobBilet: "", sobBall: ""}],
          },
        ],
  );

  return (
    <Row>
      <Col md={"5"}>
        <h2>Протокол</h2>
      </Col>
      <Col md={"7"}>
        <PrintAll Template={[TemplateProtokol]} templateData={templateData} />
      </Col>
      <hr />
      {templateData?.map((val, index) => {
        // console.log("templateData val", val)
        return (
          <Row key={index}>
            <FormProtokol
              index={index}
              templateData={templateData}
              setTemplateData={setTemplateData}
              defaultData={val}
            />
            <Col md={"7"} key={index}>
              <h3>
                Пример{" "}
                <Button onClick={() => PrintElem("contentProtokol" + index)} size={"sm"}>
                  Печать
                </Button>
              </h3>
              <div id={"contentProtokol" + index} className={"PrintPreview"}>
                <div
                  className="wrapperPrint body2"
                  dangerouslySetInnerHTML={{__html: TemplateProtokol(val)}}
                />
              </div>
            </Col>
            <hr />
          </Row>
        );
      })}
    </Row>
  );
}
